if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super()

      this.form = this.querySelector('form')
      this.form?.addEventListener('submit', this.onSubmitHandler.bind(this))
      this.form?.addEventListener('CUSTOM_SUBMIT', this.onSubmitHandler.bind(this))
      this.bubble = document.getElementById('cart-icon-bubble');
      this.isBundle = this.dataset.bundle === 'true'
    }

    async prepareBundleId () {
      const { id: variantId, 'product-id': productId, selling_plan: sellingPlan } = JSON.parse(serializeForm(this.form))

      const settings = await recharge.cdn.getCDNBundleSettings(productId)
      const defaultSelections = settings.variants.flatMap(variant => variant.selection_defaults.map(e => ({
        id: e.external_variant_id,
        quantity: e.quantity
      })))

      const variants = await this.getVariants(defaultSelections.map(e => `gid://shopify/ProductVariant/${e.id}`))
      const bundleItems = defaultSelections.map(selection => {
        const variant = (variants?.data?.nodes || []).find(e => +e.id.split('/').pop() === +selection.id)
        return {
          quantity: selection.quantity,
          externalVariantId: selection.id,
          externalProductId: (variant?.product?.id || '').split('/').pop(),
          collectionId: ((variant?.product?.collections?.nodes || [])[0]?.id || '').split('/').pop()
        }
      })

      return await recharge.bundle.getBundleId({
        externalVariantId: variantId,
        externalProductId: productId,
        selections: bundleItems
      })
    }

    async getVariants(ids) {
      return await fetch(`https://${window.Shopify.shop}/api/2025-01/graphql.json`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': this.dataset.accessToken
        },
        body: JSON.stringify({
          query: `query getBundleItems($ids: [ID!]!){
            nodes(ids: $ids) {
              ... on ProductVariant {
                id
                product {
                  id
                  collections(first: 1) {
                    nodes {
                      id
                    }
                  }
                }
              }
            }
          }`,
          variables: {
            ids
          }
        })
      }).then(res => res.json())
    }

    async onSubmitHandler(evt) {
      evt.preventDefault()
      document.dispatchEvent(new CustomEvent('cart:loading'))

      const submitButton = this.querySelector('[type="submit"]')
      const statusBlock = document.querySelector('product-totals')
      let formData;

      submitButton.setAttribute('disabled', true)
      submitButton.classList.add('loading')

      try {
        formData = JSON.parse(serializeForm(this.form))
        
        if (this.isBundle) {
          const rbId = await this.prepareBundleId()
          formData['properties'] = {
            ...formData['properties'],
            '_rb_id': rbId
          }
        }

        const cartApi = window.CartApi.getInstance()
        await cartApi.addToCart([formData])
        this.miniCart = document.querySelector('lit-mini-cart');
        if (this.miniCart) {
          this.miniCart.open()
        }

      } catch (error) {
        console.error('Error adding to cart:', error)
        this.handleErrorMessage(error.message)
      } finally {
        submitButton.classList.remove('loading')
        submitButton.removeAttribute('disabled')
        statusBlock?.updateText(formData?.quantity)

        try {
          fetch(`${routes.cart_url}`)
            .then(response => response.json())
            .then(data => {
              this.bubble.innerHTML = data.item_count;
              const form_variant_id = formData?.id
              const form_max_quantity = formData?.max_quantity
              data.items.forEach((item) => {
                if (item.variant_id == form_variant_id) {
                  if (item.quantity >= form_max_quantity && form_max_quantity != null) {
                    submitButton.setAttribute('disabled', '')
                  }
                }
              })
            })
            .catch((e) => {
              console.log(e)
              console.error(e)
            })
            .finally(() => {
              document.dispatchEvent(new CustomEvent('cart:loaded'))
            });
        } catch (e) {
          console.log("Catch error")
          console.log(e)
        }

        document.dispatchEvent(new CustomEvent('cart:loaded'))
      }
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');

      if (this.errorMessageWrapper == undefined) {
        return;
      }

      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  }

  customElements.define('product-form', ProductForm)
}